import { Button } from "@/components/ui/Button";
import { ArrowRight } from "lucide-react";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const CallingSection = () => {
    const { t } = useTranslation();
    const { ref, isVisible } = useScrollAnimation();

    return (
        <section
            ref={ref}
            id="about"
            className={`py-20 md:py-24 bg-calling-bg transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
                }`}
        >
            <div className="max-w-7xl mx-auto px-6">
                <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
                    <div className="relative order-2 lg:order-1">
                        <div className="aspect-[4/5] w-full overflow-hidden rounded-[2rem] shadow-xl">
                            <img
                                src="/images/serving-meals.jpg"
                                alt="Volunteer serving a meal in community service"
                                className="w-full h-full object-cover"
                                loading="lazy"
                            />
                        </div>
                        <div
                            aria-hidden="true"
                            className="hidden md:block absolute -bottom-8 right-0 lg:-right-8 w-48 bg-card rounded-2xl shadow-xl p-5 border border-border"
                        >
                            <div className="flex items-center gap-3">
                                <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
                                    <span className="text-xl">🌍</span>
                                </div>
                                <div>
                                    <p className="text-xs text-muted-foreground">{t('homepage.calling.badgeLabel')}</p>
                                    <p className="text-sm font-semibold text-foreground">{t('homepage.calling.badgeValue')}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="order-1 lg:order-2">
                        <span className="inline-block text-sm font-semibold text-primary uppercase tracking-wider mb-4">
                            {t('homepage.calling.eyebrow')}
                        </span>
                        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-calling-text mb-6 leading-tight">
                            {t('homepage.calling.title')}
                        </h2>
                        <p className="text-lg md:text-xl text-calling-text/80 mb-8 leading-relaxed">
                            {t('homepage.calling.description')}
                        </p>
                        <Button
                            asChild
                            size="lg"
                            className="bg-primary hover:bg-primary/90 text-primary-foreground text-base px-7 py-6 rounded-full group"
                        >
                            <Link to="/how-it-works">
                                {t('homepage.calling.cta')}
                                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
                            </Link>
                        </Button>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CallingSection;
